import {
    SAILS_VVL_STORAGE,
    SAILS_PARAM_CUSTOMER,
    SAILS_PARAM_DEVICE_ID,
    SAILS_PARAM_TAUSCHBONUS,
    SAILS_PARAM_TRADE_IN,
    GigakombiType,
    BTX_VVL,
    BTX_BNT,
} from '@vfde-sails/constants';
import {
    GetAllDiscountsOptions,
    getAllDiscounts,
} from '@vfde-sails/page-options';
import {
    getSessionStorageItemJson,
    SailsVvlStorage,
} from '@vfde-sails/storage';
import redPlusSlice, { selectAvailableSubscriptionIds } from 'Container/App/slice';
import {
    AppFlow,
    InitialState,
} from 'Container/App/interface';
import getSalesChannel from 'Container/App/helpers/getSalesChannel';

/**
 *  Get all discounts
 */
export const getDiscounts = (state: InitialState): string[] => {
    const storage = getSessionStorageItemJson<SailsVvlStorage>(SAILS_VVL_STORAGE);

    if (!storage) {
        return [];
    }

    const subscriptionIds = selectAvailableSubscriptionIds({ [redPlusSlice.name]: state });
    const customerConfig = state.customerConfig;
    const gigakombiType = storage?.[SAILS_PARAM_CUSTOMER]?.gigakombiType as GigakombiType;
    const isGigakombiEligible = storage?.[SAILS_PARAM_CUSTOMER]?.isGigakombiEligible;
    const deviceId = storage?.[SAILS_PARAM_DEVICE_ID] as string;
    const salesChannel = getSalesChannel();
    const isTauschbonus = !!storage?.[SAILS_PARAM_TAUSCHBONUS];
    const isTradeIn = !!storage?.[SAILS_PARAM_TRADE_IN];
    const btx = customerConfig.flow === AppFlow.Vvl ? BTX_VVL : BTX_BNT;

    const allDiscountsOptions: GetAllDiscountsOptions = {
        salesChannel,
        deviceId,
        subscriptionIds,
        isGigakombi: isGigakombiEligible && !!gigakombiType,
        gigakombiType,
        isTradeIn,
        isTauschbonus,
        isRestlaufzeit: false,
        btx,
    };
    const discountIds = getAllDiscounts(allDiscountsOptions);

    return discountIds;
};
